<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim :options="notfound" class="anim" :height="getScreen ? 200 : 500" :width="getScreen ? 200 : 500"></m-anim>
        <h3>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block @click="$router.go(-1)">
          <a-icon type="rollback" />&nbsp; Return
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="15">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="pageLoading" class="margin-bottom">
            <div slot="title">
              Recapitulation Release Manifest
              <small class="m-display-block m-text-small">{{
                data.invoice[0].no_rilis
              }}</small>
            </div>
            <a-popover slot="extra" trigger="click" placement="bottom">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <!-- <li>
                  <a-button @click="handlePrintManifest" type="dashed" icon="printer" block class="m-display-block"
                    :loading="printLoad">Manifest</a-button>
                </li> -->
                <li>
                  <a-button
                  :disabled="
                    !( data.invoice[0].status == 'Revised' &&
                      getAuth.username ==
                        (data.invoice
                          ? data.invoice[0].tlc
                          : '')
                    )"
                    type="dashed"
                    icon="edit"
                    class="width-full"
                    @click="handleEdit(data.invoice[0].id_rilis)"
                    >Edit</a-button
                  >
                  <a-button
                    :disabled="!(data.invoice[0].status == 'Revised' &&
                      getAuth.username ==
                        (data.invoice
                          ? data.invoice[0].tlc
                          : '')
                    )"
                    type="danger"
                    icon="close-square"
                    class="width-full margin-top"
                    :loading="loading.cancel"
                    @click="handleCancel()"
                    >Cancel</a-button
                  >
                </li>
              </ul>
              <a-button icon="more">{{ getScreen ? "" : "Action" }}</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Date Created</span>
                  <span class="m-list-desc">{{
                    moment(data.invoice[0].create_dt, getStandartFormatDate).format(
                      getDefaultDateFormat
                    )
                  }}</span>
                </li>
                <!-- <li>
                  <span class="m-list-title">No {{ data.header.no_bg !== '-' ? 'Bilyet Giro' : data.header.no_cek !== '-'
                    ?
                    'Cek' : (data.header.autodebet_no !== '-' ? 'Auto Debet' : 'Atm') }}</span>
                  <span class="m-list-desc">{{ data.header.no_bg !== '-' ? data.header.no_bg : data.header.no_cek !== '-'
                    ? data.header.no_cek : data.header.no_atm !== "-" ? data.header.no_atm :
                      data.header.autodebet_no }}</span>
                  <br /><span class="m-list-desc">
                    {{ data.header.no_bg !== '-' ? "[ Due Date:" + (data.header.jatuh_tempo_dt ?
                      moment(data.header.jatuh_tempo_dt).format("DD - MM - YYYY")
                      : '-') + " ]" : " " }}</span>
                </li> -->
                <li>
                  <span class="m-list-title" for>User Creator</span>
                  <span class="m-list-desc">{{ data.invoice[0].nama }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Cost Center</span>
                  <span class="m-list-desc">{{ data.invoice[0].cost_center_kode }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Financial Item | Code</span>
                  <span class="m-list-desc">{{ data.invoice[0].item_anggaran }} | {{ data.invoice[0].kode_anggaran }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Be Required</span>
                  <span class="m-list-desc">{{ data.invoice[0].be_required ? moment(data.invoice[0].be_required,getStandartFormatDate).format(getDefaultDateFormat) : '' }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>End User</span>
                  <span class="m-list-desc">{{ data.invoice[0].end_user }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Currency</span>
                  <span class="m-list-desc">{{ data.invoice[0].currency }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Value</span>
                  <span class="m-list-desc">{{
                    formatCurrency(
                      data.invoice[0].currency,
                      Number(data.invoice[0].value_asli)
                    )
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Note</span>
                  <span class="m-list-desc">{{ data.invoice[0].catatan }}</span>
                </li>
              </ul>
            </div>
          </a-card>
          <a-collapse class="margin-top margin-bottom" activeKey="1" v-model="activeKey">
            <a-collapse-panel key="1">
              <div class="m-display-flex space-between align-middle" slot="header">
                <h4 class="margin-remove">Usage Details</h4>
                <!-- <div v-if="data.file_attachment === null">
                  <a-button @click="editList" type="default" size="small" class="margin-right-small">
                    Edit
                    <a-icon type="edit" />
                  </a-button>
                </div> -->
              </div>
              <a-input-search
                v-model="search"
                placeholder="Quick Search"
                allowClear
                :change="searching"
                class="margin-bottom"
              />
              <a-table :rowKey="(record, index) => {return index;}" id="transd" :columns="columns" :dataSource="data.dtl_invoice"
                :pagination="pagination" size="small" bordered :scroll="uploaded ? { x: 1300 } : { x: 950 }">

                <span slot="no" slot-scope="text,data,index">{{ index + 1 }}</span>

                <span slot="value" slot-scope="item">
                  <CurrencyJustified :currencyValue="data.invoice[0].currency" :valueNumber="parseFloat(item.value)" />
                </span>

                <span slot="doc_tax" slot-scope="item">
                  <div style="text-align: center;">
                    <a-button icon="edit" size="small"
                      :type="item.kode_setoran_pajak != null && item.kode_setoran_pajak != null ? 'primary' : 'danger'"
                      style="margin-right:5px" @click="handleShowTaxModal(item)"
                      :disabled="!(data.jenis == 'Verifikator' && item.type == 'Tax')">
                    </a-button>

                    <!-- <a-button icon="file" disabled size="small"
                      v-if="item.type == 'Tax' && item.document_tax == 'No File Uploaded'">
                    </a-button>
                    <a-button icon="file" @click="handleViewDocLink(item)" size="small"
                      v-if="item.type == 'Tax' && item.document_tax != 'No File Uploaded'">
                    </a-button> -->
                  </div>
                </span>

              </a-table>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-card :loading="pageLoading" :class="getScreen ? 'margin-top' : ''">
            <div slot="title">Evidence of Transfer</div>
            <div>
              <a-alert v-if="data.detail_bukti_transfer.length <= 0" type="error" message="No evidence of transfer was uploaded"
                banner />
              <a-list itemLayout="horizontal" :dataSource="data.detail_bukti_transfer" v-else>
                <Empty v-if="data.detail_bukti_transfer
                  ? data.detail_bukti_transfer.length <= 0
                  : data.detail_bukti_transfer
                  " />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between">
                      <div style="max-width:50%">
                        <h3 class="margin-remove" style="margin-bottom: 5px !important;">
                          {{ moment(item.tgl_tf).format(getDefaultDateFormat) }}
                        </h3>
                        <a-button @click="handleViewDt(item)" size="small" type="default" icon="eye">View</a-button>
                      </div>
                      <h4 class="margin-remove">
                        {{ formatCurrency(data.currency, item.value_tf) }}
                      </h4>
                    </div>
                    <img v-if="item.url.indexOf('.pdf') >= 0" class="m-image-icon" slot="avatar"
                      src="@/assets/icon/pdf_ico.png" />
                    <img v-else class="m-image-icon" slot="avatar" :src="$serviceUrl + item.url" />
                    <p slot="description" class="margin-remove">
                      {{ item.user_tf }}
                    </p>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </div>
          </a-card>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status :status="data.invoice[0].status" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    History
                    <a-icon type="history" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">
                    Creator - {{ data.invoice[0].tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">
                      {{
                        moment(data.invoice[0].create_dt).format(
                          getDefaultDateFormat
                        )
                      }}
                    </h4>
                    <span class="m-text-small" v-if="data.invoice[0].catatan">
                      {{ data.invoice[0].catatan }}
                    </span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  v-for="workflow in data.status_app"
                  :key="workflow.step_no"
                  :color="
                    workflow.status === 'On Process' ||
                    workflow.status === 'Delivered'
                      ? 'red'
                      : workflow.status === 'Waiting'
                      ? 'grey'
                      : 'green'
                  "
                >
                  <div class="m-timeline-title">
                    {{
                      workflow.actor === null ? workflow.jenis : workflow.actor
                    }}
                    {{ workflow.tlc ? " - " + workflow.tlc : "" }}
                  </div>
                  <div class="m-timeline-body">
                    <h4
                      class="margin-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >
                      {{ moment(workflow.tanggal_aksi).format(getDefaultDateFormat) }}
                    </h4>
                    <span class="m-text-small" v-if="workflow.remark">
                      {{ workflow.remark }}
                    </span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Related Document</h4>
              </div>

              <a-list
                itemLayout="horizontal"
                :dataSource="data.dokumen_terkait"
              >
                <Empty
                  v-if="
                    data.dokumen_terkait
                      ? data.dokumen_terkait.length <= 0
                      : data.dokumen_terkait
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-top"
                    >
                      <a @click="handleView(item)"
                      style="text-wrap: wrap;max-width: 50%;"
                      >{{ item.header }} | {{ item.tlc }}</a
                      >
                      <Status
                        v-if="item.status"
                        :class="!getScreen ? 'margin-remove' : ''"
                        :status="item.status"
                      />
                    </div>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                      v-if="item.no_manifest"
                    >
                      <span>{{ item.no_manifest }}</span>
                    </div>
                    <div slot="description" v-if="item.tgl_mulai_dinas">
                      <span
                        >{{
                          moment(
                            item.tgl_mulai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}
                        -
                        {{
                          moment(
                            item.tgl_selesai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}</span
                      >
                    </div>
                    <div slot="description">
                      <div class="m-width-full">
                        <a-tooltip
                          class="ant-tooltip-inner"
                          placement="top"
                          :title="
                            item.deskripsi
                              ? item.deskripsi
                              : 'Tidak ada deskripsi'
                          "
                        >
                          <span class="ant-description-ellipses">{{
                            item.deskripsi
                              ? item.deskripsi
                              : "Tidak ada deskripsi"
                          }}</span>
                        </a-tooltip>
                      </div>
                    </div>
                    <div
                      slot="title"
                      v-if="
                        item.estimated_value && item.rest_api !== 'supplier'
                      "
                    >
                      <span class="m-timeline-title">{{
                        formatCurrency(item.currency, item.estimated_value)
                      }}</span>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card
            class="margin-top"
            v-if="data.jenis === 'Transfer' && status_transfer"
          >
            <div slot="title">
              Manifest Actions &nbsp;<i
                v-if="data.jenis == 'Transfer' && !status_transfer"
                style="color:red!important"
                >(Funding has not been set)</i
              >
            </div>
            <div class="m-text-align right margin-remove" slot="extra">
              <h5 class="m-text-align right margin-remove">
                remaining balance
              </h5>
              <a-tag color="green" class="m-text-align right margin-remove">{{
                formatCurrency(currency, sisa_tf)
              }}</a-tag>
            </div>
            <template v-if="!(data.jenis == 'Transfer' && !status_transfer)">
              <a-form :form="form">
                <a-row :gutter="16">
                  <a-form-item label="Status">
                    <a-select
                      @change="onChangeStatus"
                      v-decorator="[
                        'aksi',
                        {
                          rules: [{ required: true }],
                          initialValue: data.aksi[0].aksi,
                        },
                      ]"
                    >
                      <a-select-option
                        v-for="da in data.aksi"
                        :key="da.aksi"
                        >{{ da.aksi }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Transfer Date">
                    <a-date-picker
                      placeholder="Select Date"
                      :format="dateFormat"
                      v-decorator="['tgl_tf', { rules: [{ required: true }] }]"
                    />
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Upload Bukti Transfer">
                    <a-upload
                      :fileList="fileList"
                      v-decorator="[
                        'file_transfer',
                        { rules: [{ required: reqFileTf }] },
                      ]"
                      accept=".jpg, .png, .pdf"
                      :remove="handleRemoveTransfer"
                      :beforeUpload="beforeUploadTransfer"
                    >
                      <a-button> <a-icon type="upload" />Select File </a-button>
                    </a-upload>
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Transfer Value">
                    <a-checkbox
                      :defaultChecked="true"
                      @change="onchangeNilaiTf"
                      :checked="checkTransferValue"
                      >Transfer value according to remaining balance</a-checkbox
                    >
                    <a-input-number
                      :min="0.1"
                      :max="sisa_tf"
                      class="m-display-block"
                      v-decorator="[
                        'value_transferan',
                        {
                          rules: [{ required: true }],
                          initialValue: temp_sisa_tf,
                        },
                      ]"
                      :disabled="disableNilaiTf"
                    ></a-input-number>
                  </a-form-item>

                  <a-form-item label="Note">
                    <a-textarea
                      placeholder="Write the note here ... "
                      :rows="4"
                      v-decorator="['catatan', { rules: [{ required: false }] }]"
                    />
                  </a-form-item>
                </a-row>
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-button
                    @click="handleActionConfirm"
                    block
                    type="primary"
                    html-type="submit"
                    :loading="loading.trans_verif"
                    >Save</a-button
                  >
                </a-form-item>
              </a-form>
            </template>
          </a-card>

          <a-card
            class="margin-top"
            v-if="data.jenis === 'Verifikator' || data.jenis === 'Approve'"
          >
            <div slot="title">Manifest Actions</div>

            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Aksi">
                <a-select
                  v-decorator="[
                    'aksi',
                    {
                      rules: [{ required: true }],
                      initialValue: data.aksi[0].aksi,
                    },
                  ]"
                >
                  <a-select-option
                    v-for="item in data.aksi"
                    :key="item.aksi"
                    >{{ item.aksi }}</a-select-option
                  >
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button
                  @click="handleActionConfirm"
                  block
                  type="primary"
                  html-type="submit"
                  :loading="loading.trans_verif"
                  >Save</a-button
                >
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>
      </a-row>
    </div>

    <a-modal v-model="visibleLampiran" @ok="addLampiran" :footer="null" @cancel="cancelLampiran" :width="1000">
      <span slot="title">
        <a-icon type="upload" />&nbsp;Upload Attachment
      </span>

      <a-row class="margin-bottom">
        <a-col>
          <a-table v-if="visible_value_bkk" rowKey="id_transaksi" bordered size="small" :scroll="{ x: 700, y: 150 }"
            :pagination="false" :columns="columnsListData" :loading="false" :data-source="list_data">
            <a slot="no_transaksi" slot-scope="item">{{ item.no_transaksi }}
            </a>
            <span slot="value" slot-scope="item">
              <CurrencyJustified :currencyValue="item.currency" :valueNumber="parseFloat(item.value)" />
            </span>
            <span slot="valueBayartable" slot-scope="itemn">
              {{ formatRupiah(itemn).replace("Rp", "").replace(",00", "") }}
            </span>
            <div slot="actionBayartable" style="align: center" slot-scope="item">
              <a-popover :visible="popoverdtlpendanaan == item.no" :key="item.no" placement="leftTop" trigger="hover">
                <template slot="content">
                  <a-card>
                    <span slot="title">Insert Value Exchange Rate</span>
                    <a-form-item>
                      <a-input-number class="m-width-full m-text-align right" v-model="inputEditvalue" :min="0" />
                    </a-form-item>
                    <a-button-group ghost block class="m-width-full m-text-align right">
                      <a-button type="primary" @click="simpanEditListData()">
                        Save
                      </a-button>
                      <a-button type="danger" @click="cancelEditListData()">
                        Cancel
                      </a-button>
                    </a-button-group>
                  </a-card>
                </template>
              </a-popover>
              <a-button size="small" type="primary" icon="edit" :disabled="item.currency === item.currency_to"
                @click="handleShowValue(item)" />
            </div>
            <span slot="value_real" slot-scope="item">
              <CurrencyJustified :currencyValue="item.currency_to" :valueNumber="parseFloat(item.value_real)" />
            </span>
          </a-table>
        </a-col>
      </a-row>

      <!-- <a-row type="flex" justify="space-between" :gutter="10">
        <a-col :span="24">
          <a-card>
            <a-form :form="formLampiran">
              <a-form-item label="Document Name">
                <a-input autocomplete="off" v-decorator="[
                  'document_name',
                  { rules: [{ required: true }] },
                ]"></a-input>
              </a-form-item>
              <a-form-item label="Due Date" v-if="this.data.header.no_bg != '-'">
                <a-date-picker placeholder="Select Date" v-decorator="['due_date', { rules: [{ required: true }] }]"
                  format="DD-MM-YYYY" allowClear />
              </a-form-item>
              <a-form-item label="Upload Document File">
                <a-upload :showUploadList="true" :beforeUpload="beforeUpload" :remove="handleRemove" v-decorator="[
                  'file_list_lampiran',
                  { rules: [{ required: true }] },
                ]" :fileList="fileListLampiran">
                  <a-button ref="btndocument" :disabled="fileListLampiran.length > 0" icon="upload">Select File
                  </a-button>
                </a-upload>
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>
      </a-row> -->

      <a-card v-if="visible_value_bkk" title="Cost BKK" class="margin-top">
        <a-row type="flex" justify="space-between" :gutter="10">
          <a-col :span="8">
            <a-form :form="formCost">
              <a-form-item label="Cost Name">
                <a-input v-decorator="['cost_name', { rules: [{ required: true }] }]"></a-input>
              </a-form-item>
              <a-form-item label="Cost Value">
                <a-input-number type="number" :min="1" class="m-width-full m-text-align-right"
                  v-decorator="['cost_value', { rules: [{ required: true }] }]">
                </a-input-number>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button @click="handleTambahCostBKK" :loading="tambahLoading" block html-type="submit">{{
                  this.statusEditCostBKK ? "Update" : "Tambahkan"
                }}</a-button>
              </a-form-item>
            </a-form>
          </a-col>
          <a-col :span="16">
            <a-table :rowKey="(record, index) => { return index; }" id="transd" :columns="columnsCostBKK"
              :dataSource="cost_bkk" :pagination="pagination" size="small" bordered :scroll="{ x: 600 }">
              <span slot="cost_value" slot-scope="item">
                <CurrencyJustified :currencyValue="data.header.currency" :valueNumber="parseFloat(item.cost_value)" />
              </span>
              <div slot="actionBayartable" style="align: center" slot-scope="item">
                <a-button-group size="small">
                  <a-button :disabled="statusEditCostBKK" type="primary" @click="handleEditCostBKK(item)">
                    <a-icon type="edit" />
                  </a-button>
                  <a-button :disabled="statusEditCostBKK" type="danger" @click="handleRemoveCostBKK(item)">
                    <a-icon type="close" />
                  </a-button>
                </a-button-group>
              </div>
              <template slot="footer" slot-scope="item">
                <div class="footer-calc">
                  <a-row :gutter="8">
                    <a-col :xs="{ span: 6 }" :lg="{ span: 11 }">
                      <span>Total Real Cost Value</span>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="6">
                      <span class="m-text-align m-text-bold">
                        {{ formatCurrencyCode(data.header.currency, totalRealCostList) }}
                      </span>
                    </a-col>
                  </a-row>
                </div>
                <div class="footer-calc">
                  <a-row :gutter="8">
                    <a-col :xs="{ span: 6 }" :lg="{ span: 11 }">
                      <span>Total Cost Value</span>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="6">
                      <span class="m-text-align m-text-bold">
                        {{ formatCurrencyCode(data.header.currency, totalCostBKK) }}
                      </span>
                    </a-col>
                  </a-row>
                </div>
                <div class="footer-calc">
                  <a-row :gutter="8">
                    <a-col :xs="{ span: 6 }" :lg="{ span: 11 }">
                      <span>Grand Total</span>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="6">
                      <span class="m-text-align m-text-bold">
                        {{
                          formatCurrencyCode(
                            data.header.currency,
                            isRoundingBKKValue && isRoundingBKKValue == "1" ? Math.ceil(totalRealCostList + totalCostBKK) :
                              (totalRealCostList + totalCostBKK)
                          )
                        }}
                      </span>
                    </a-col>
                  </a-row>
                </div>
              </template>
            </a-table>
          </a-col>
        </a-row>
      </a-card>

      <a-row type="flex" justify="end" :gutter="10" class="margin-top">
        <a-col :span="4">
          <a-button type="danger" style="float: right; vertical-align: middle" @click="handleUploadLampiran"
            :loading="uploadLoading">
            Save
          </a-button>
        </a-col>
      </a-row>
    </a-modal>

    <a-modal v-model="editModal" :maskClosable="false" @cancel="handleClose" @ok="handleEditModal" :footer="null"
      :width="900">
      <span slot="title">
        <a-icon type="edit" class="margin-right-small" />Edit Transaction
      </span>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
          <a-form-model ref="tlForm" :model="tlForm" :rules="tlRules">
            <a-form-model-item label="Type Number" prop="type">
              <a-radio-group buttonStyle="solid" v-model="tlForm.type" ref="site" @change="handlechangegenBKK">
                <a-radio-button type="Radio" value="bilyet_giro" ref="bilyet_giro">No Billyet Giro</a-radio-button>
                <a-radio-button type="Radio" value="no_cek" ref="no_check">Check Number</a-radio-button>
                <a-radio-button type="Radio" value="no_atm" ref="no_atm">No Atm</a-radio-button>
                <a-radio-button type="Radio" value="auto_debet" ref="auto_debet">Auto Debet</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item prop="typeValue">
              <a-input autocomplete="off" v-model="tlForm.typeValue" />
            </a-form-model-item>
            <a-row :gutter="8" v-if="tlForm.type == 'auto_debet' || tlForm.type == 'no_cek' || tlForm.type == 'no_atm'">
              <a-col :xs="{ span: 12 }" :lg="{ span: 12 }">
                <a-form-model-item label="Trans Date" prop="trans_date">
                  <a-date-picker placeholder="Select Date" v-model="tlForm.trans_date" :disabledDate="disabledDate"
                    format="DD-MM-YYYY" allowClear />
                </a-form-model-item>
              </a-col>
              <a-col :xs="{ span: 12 }" :lg="{ span: 12 }">
                <a-form-model-item label="Upload File Support" prop="upload" v-if="tlForm.type == 'auto_debet'">
                  <a-upload :showUploadList="true" :fileList="pushfile" :beforeUpload="beforeUploadFile"
                    :remove="handleRemoveFile" v-model="tlForm.upload">
                    <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
                  </a-upload>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-form-item label="Rounding Total Value">
              <a-radio-group v-model="isRoundingBKKValue" buttonStyle="solid">
                <a-radio-button type="Radio" value="0">No</a-radio-button>
                <a-radio-button type="Radio" value="1">Yes</a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-form-model>
        </a-col>
      </a-row>

      <a-table rowKey="key" :columns="column_process" :dataSource="list_process" :pagination="pagination" size="small"
        :loading="listProcessLoading" bordered :scroll="{ x: 1000, y: 500 }">
        <template slot="title">
          <div class="table-header">
            <div>
              <h4 class="margin-remove title">Process List</h4>
              <small>Selected {{ selectedData.length }}</small>
            </div>
            <div class="table-header-extra">
              <a-input-search v-model="search" placeholder="Input Search Text" @change="onChangeSearch" />
            </div>
          </div>
        </template>
        <a slot="no" slot-scope="item" @click="handleLink(item.jenis, item.id, item.no_transaksi, item.pembuat)">{{
          item.no }}</a>
        <span slot="value" slot-scope="amount">
          <CurrencyJustified v-if="amount.value" :currencyValue="amount.currency" :valueNumber="amount.value" />
          <div v-else style="text-align: center; width: 100%">-</div>
        </span>
        <span slot="update_by" slot-scope="item">
          <span v-if="item.tlc_updated">
            {{ item.tlc_updated }} /
            {{
              item.date_updated
              ? moment(item.date_updated, getDateTimeStandartFormat).format(
                getDefaultDateFormat
              )
              : "-"
            }}
          </span>
          <span v-else> - </span>
        </span>
        <span slot="centang" slot-scope="item">
          <a-checkbox :default-checked="item.dana_sts" :key="item.key" @change="changeActionItem(item)" />
        </span>
      </a-table>
      <a-row type="flex" justify="end" :gutter="0" class="margin-top">
        <a-col :span="20">
          <a-button type="danger" style="float: left; vertical-align: middle" @click="handleCancelEdit"
            :loading="uploadLoading">
            Cancel
          </a-button>
        </a-col>
        <a-col :span="4">
          <a-button style="float: right; vertical-align: middle" @click="handleSubmitEdit" :loading="submitLoading">
            Submit
          </a-button>
        </a-col>
      </a-row>
    </a-modal>

    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="history" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.notifikasi" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }}
                {{ history.tlc_from ? "|" + history.tlc_from : "" }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }}
                {{ history.tlc_from ? "|" + history.tlc_from : "" }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }}
                {{ history.tlc_to ? "|" + history.tlc_to : "" }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>

    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancelPreview">
      <div class="margin-top"></div>
      <a-divider class="margin-small" />
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>

    <TaxDepositEntry
      name="axDepositEntry"
      :v-if="visibleTaxModal"
      :visibleTaxModal="visibleTaxModal"
      :getType_tax="getType_tax"
      :getListsetoranpajak="datapajak.getListsetoranpajak"
      :getListobjekpajak="datapajak.getListobjekpajak"
      :tax_type="datapajak.tax_type"
      :file_document_tax="datapajak.file_document_tax"
      :kode_setoran_pajak="datapajak.kode_setoran_pajak"
      :objek_pajak="datapajak.objek_pajak"
      :id_header="datapajak.id_header"
      :id_dtl="datapajak.id_dtl"
      :dpp_value="datapajak.dpp_value"
      :value="datapajak.value"
      :file="datapajak.fileList"
      jenis_transaksi="rilis_rekap"
      :hideUploadDocTax="true"
    />
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import moment from "moment";
import shortingArray from "@/mixins/MultishortArray";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import TaxDepositEntry from "@/components/TaxDepositEntry.vue";
import lottie from "vue-lottie";
import notfound from "@/assets/anim/404.json";
import _ from "lodash";

export default {
  name: "ManifestPIRelease",
  components: {
    "m-anim": lottie,
    TaxDepositEntry
  },
  props: ["id", "user_pembuat"],
  mixins: [CurrencyFormat, HandleRoute, shortingArray, GlobalMethod],
  data() {
    let doc_validation = (rule, value, callback) => {
      if (this.pushfile == null) {
        callback(new Error("Upload File Cannot be Empty!"));
      } else {
        callback();
      }
    };
    return {
      data: {
        notfound: { animationData: notfound, loop: true },
        invoice: [{
          no_rilis: "",
          bkk_id: "",
          create_dt: "",
          keterangan: "",
          kode_rekening: "",
          nama_bank: "",
          no_bg: "",
          no_bkk: "",
          no_cek: "",
          no_atm: "",
          tlc_create: "",
          total_nilai_terbilang: "",
          value_bkk: "",
        }],
        file_attachment: [],
        transaction_list: [],
        cost_list: [],
        attachment: [
          {
            file_attachment: null,
            file_attachment_url: null,
            create_dt: null,
            document_name: null,
          },
        ],
        detail_bukti_transfer: [],
      },
      currency: "IDR",
      currencyorigin: "",
      jenistransaksi: undefined,
      pageLoading: false,
      uploadLoading: false,
      tambahLoading: false,
      printLoad: false,
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
      visibleLampiran: false,
      fileListLampiran: [],
      visible_value_bkk: false,
      totalRealCost: 0,
      totalCost: 0,
      grandTotal: 0,
      uploaded: false,
      list_data: [],
      popoverdtlpendanaan: undefined,
      inputEditvalue: "",
      inputEditid: {},
      cost_bkk: [],
      statusEditCostBKK: false,
      keyEditCostBKK: {},
      totalRealCostList: 0,
      totalCostBKK: 0,
      widthForm: 600,
      spanCol: 24,
      editModal: false,
      list_process: [],
      selectedData: [],
      search: undefined,
      submitLoading: false,
      listProcessLoading: false,
      activeKey: ["1"],
      tlForm: {},
      tlRules: {
        type: [{ required: true }],
        typeValue: [{ required: true, message: "Type Number Cannot be Empty!" }],
        trans_date: [{ required: true, message: "Trans Date Cannot be Empty!" }],
        upload: [{ required: true, validator: doc_validation, }],
      },
      pushfile: [],
      isRoundingBKKValue: "0",
      doc_validation,
      changegenBKKval: "",
      visibleHistory: false,
      visibleTaxModal: false,
      datapajak: {
        getListsetoranpajak: {},
        getListobjekpajak: {},
        tax_type: "",
        file_document_tax: null,
        kode_setoran_pajak: "",
        objek_pajak: "",
        id_header: "",
        id_dtl: "",
        status_transfer: false,
      },
      loading: {
        cancel: false,
        trans_verif: false,
        page: false,
      },
      status_transfer: false,
      sisa_tf: "",
      temp_sisa_tf: "",
      reqFileTf: true,
      fileList: [],
      checkTransferValue: true,
      dateFormat: "DD MMMM YYYY",
      disableNilaiTf: true,
      previewVisible: false,
      previewImage: "",
    };
  },
  beforeCreate() {
    this.formLampiran = this.$form.createForm(this);
    this.formCost = this.$form.createForm(this);
    this.form = this.$form.createForm(this);
  },
  watch: {
    "tlForm.type"() {
      if (this.tlForm.type == "bilyet_giro") {
        this.tlForm.typeValue = this.tlForm.no_bilyet;
      } else if (this.tlForm.type == "no_cek") {
        this.tlForm.typeValue = this.tlForm.no_cek;
      } else {
        this.tlForm.typeValue = this.tlForm.no_atm;
      }
    },
    id() {
      if (this.id) {
        this.fetchManifest();
        this.form = this.$form.createForm(this);
        this.fileList = [];
        this.checkTransferValue = true;
        this.disableNilaiTf = true;
        this.reqFileTf = true;
      }
    },
  },
  mounted() {
    this.$store.dispatch("Fetch_TYPE_TAX");
    Event.$on("refresh", this.fetchManifest);
    Event.$on("confirmMessageDelete", this.handleRemoveLampiran);
    this.fetchManifest();
    Event.$on("confirmMessageDeleteClear", this.removeCostBKK);
    // this.fetchData();
    Event.$on("TaxDepositEntryCancel", this.taxDepositEntryCancel);
    Event.$on("TaxDepositEntryUpdate", this.taxDepositEntryUpdate);
    Event.$on("confirmMessageReturn", this.handleAction);
  },
  beforeDestroy() {
    Event.$off("refresh", this.fetchManifest);
    Event.$off("confirmMessageDelete", this.handleRemoveLampiran);
    Event.$off("confirmMessageDeleteClear", this.removeCostBKK);
    Event.$off("TaxDepositEntryCancel", this.taxDepositEntryCancel);
    Event.$off("TaxDepositEntryUpdate", this.taxDepositEntryUpdate);
    Event.$off("confirmMessageReturn", this.handleAction);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getIsSpecialMenu",
      "getDateTimeFormat",
      "getStandartFormatDate",
      "getDateTimeStandartFormat",
      "getType_tax",
    ]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          align: "right",
          key: "no",
          width: "5%",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "Item Name",
          width: "30%",
          key: "item_name",
          dataIndex: "item_name",
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "Value",
          width: "25%",
          key: "value",
          scopedSlots: { customRender: "value" },
          sorter: (a, b) => a.value - b.value,
        },
        {
          title: "Type",
          key: "type",
          width: "15%",
          dataIndex: "type",
          sorter: (a, b) => a.type.length - b.type.length,
        },

        {
          title: "Type Tax",
          align: "center",
          key: "type_tax",
          dataIndex: "type_tax_label",
          width: "15%",
        },
      ];

      if (this.isTaxOfficer) {
        kolom.push({
          title: "Tax Deposit",
          key: "doc_tax",
          fixed: "right",
          scopedSlots: { customRender: "doc_tax" },
          width: 100,
        },);
      }
      return kolom;
    },
    columnsCost() {
      const kolom = [
        {
          title: "#",
          dataIndex: "no",
          align: "center",
          key: "no",
          width: 25,
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "Cost Name",
          width: 200,
          key: "bkk_cost_nm",
          dataIndex: "bkk_cost_nm",
          sorter: (a, b) => a.description.length - b.description.length,
        },
        {
          title: "Value",
          key: "cost_value",
          width: 100,
          scopedSlots: { customRender: "cost_value" },
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },
      ];
      return kolom;
    },
    columnsListData() {
      const kolom = [
        {
          title: "#",
          dataIndex: "no",
          align: "center",
          key: "no",
          width: 40,
        },
        {
          title: "No",
          width: 200,
          key: "no_transaksi",
          scopedSlots: { customRender: "no_transaksi" },
          sorter: (a, b) => a.no_transaksi.length - b.no_transaksi.length,
        },
        {
          title: "Description",
          width: 180,
          key: "description",
          dataIndex: "description",
          sorter: (a, b) => a.description.length - b.description.length,
        },
        {
          title: "Est Value",
          key: "value",
          width: 200,
          scopedSlots: { customRender: "value" },
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },
        {
          title: "Currency to",
          key: "currto",
          dataIndex: "currency_to",
          width: 130,
          align: "center",
        },
        {
          dataIndex: "value_data",
          key: "value_data",
          title: "Exchange Rate",
          className: "editcell-wrap",
          scopedSlots: { customRender: "valueBayartable" },
          width: 110,
        },
        {
          key: "action",
          title: "Action",
          scopedSlots: { customRender: "actionBayartable" },
          width: 60,
        },
        {
          title: "Real Value",
          key: "value_real",
          width: 200,
          scopedSlots: { customRender: "value_real" },
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },
      ];
      return kolom;
    },
    columnsCostBKK() {
      const kolom = [
        {
          title: "#",
          dataIndex: "no",
          align: "center",
          key: "no",
          width: 25,
        },
        {
          title: "Cost Name",
          width: 200,
          key: "cost_name",
          dataIndex: "cost_name",
          sorter: (a, b) => a.description.length - b.description.length,
        },
        {
          title: "Value",
          key: "cost_value",
          width: 100,
          scopedSlots: { customRender: "cost_value" },
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },
        {
          key: "action",
          title: "Action",
          scopedSlots: { customRender: "actionBayartable" },
          width: 80,
        },
      ];
      return kolom;
    },
    column_process() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          key: "number",
          dataIndex: "number",
          width: 40,
          align: "center",
        },
        {
          title: "No",
          width: 150,
          key: "no",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "Description",
          key: "deskripsi",
          dataIndex: "deskripsi",
          width: 150,
        },

        {
          title: "Value",
          key: "value",
          width: 150,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "Update By",
          key: "update_by",
          width: 100,
          align: "center",
          scopedSlots: { customRender: "update_by" },
        },
        {
          title: "Generate",
          key: "centang",
          width: 50,
          align: "center",
          scopedSlots: { customRender: "centang" },
        },
      ];
      return kolom;
    },
    file_attachment_dt() {
      let result = null;
      if (this.data.attachment[0].file_attachment) {
        let arratc = this.data.attachment[0].file_attachment.split("_");
        let lastindex = arratc.length;
        result = moment(arratc[lastindex - 2], 'YYYYMMDD').format("YYYY-MM-DD").toString();
      }
      return result;
    },
    isTaxOfficer() {
      let data = _.filter(this.getAuth.nama_bidang, (obj) => obj == "Tax Officer");
      return data.length > 0 ? true : false;
    },
    searching() {
      if (this.search) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.data.dtl_invoice = this.data.dtl_invoiceOri.filter(
          (obj) =>
            obj.item_name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (!this.search) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.data.dtl_invoice = this.data.dtl_invoiceOri;
      }
      return true;
    },
    isValidTaxOfficerValue() {
      let data = _.filter(
        this.data.dtl_invoiceOri,
        (obj) =>
          obj.type == "Tax" &&
          obj.kode_setoran_pajak == null &&
          obj.type_tax &&
          obj.type_tax != "bea_masuk"
      );
      return data.length > 0 ? false : true;
    },
    statusAppLength(){
      return this.data.status_app ? this.data.status_app.length-1 : 0
    }
  },
  methods: {
    moment,
    scalegrantotal(value, scale, jutaan) {
      return scale == "juta"
        ? Math.round(value / jutaan) < 0
          ? 0
          : Math.round(value / jutaan)
        : value;
    },
    cancelEditListData() {
      this.popoverdtlpendanaan = null;
    },
    simpanEditListData() {
      if (this.inputEditvalue == null) {
        this.displayMessage("grather0");
        return;
      }


      this.list_data = this.list_data.map((value, index, arr) => {
        if (value.no === this.inputEditid.no) {
          value.value_data = this.inputEditvalue;
          value.value_real =
            // value.currency_to !== "IDR"
            //   ? this.inputEditvalue / Number(value.value)
            //   : Number(value.value) * this.inputEditvalue;
            Number(value.value) * this.inputEditvalue;
        }
        return value;
      });


      this.totalRealCostList = this.list_data.reduce(function (prev, cur) {
        return prev + Number(cur.value_real);
      }, 0);

      this.popoverdtlpendanaan = null;
    },
    handleShowValue(val) {
      this.inputEditvalue = val.value_data;
      this.inputEditid = val;
      this.popoverdtlpendanaan = val.no;
    },
    async fetchManifest() {
      this.pageLoading = true;
      await axios({
        method: "get",
        url: this.$serviceUrl + "rekap/rilis",
        params: {
          id_rilis: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.data = response.data;
          this.data['dtl_invoiceOri'] = response.data.dtl_invoice;
          this.status_transfer = response.data.status;
          this.sisa_tf = response.data.sisa_tf;
          this.temp_sisa_tf = this.sisa_tf;

          if (this.isTaxOfficer) {
            this.datapajak.getListsetoranpajak = response.data.setoran_pajak;
            this.datapajak.getListobjekpajak = response.data.objek_pajak;
            this.datapajak.tax_type = null;
            this.datapajak.file_document_tax = null;
            this.datapajak.kode_setoran_pajak = null;
            this.datapajak.objek_pajak = null;
            this.datapajak.id_header = null;
            this.datapajak.id_dtl = null;
            this.datapajak.dpp_value = null;
            this.datapajak.value = null;
            this.datapajak.fileList = null;
          }

          this.pageLoading = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            if(err.response.message){
              this.displayMessageValue("error", err.response.message);
            }else{
              this.displayMessage("404");
            }
          }
          this.data = {};
          this.pageLoading = false;
          this.$router.go(-1);
          return err;
        });
    },
    handleLink(jenis, id_, no_trans, pembuat) {
      let manifest = "";
      if (jenis == "tax_release") {
        let ids = no_trans.split("/")
        let tipe = ids[2]
        if (tipe.toLowerCase() == "pph21") {
          tipe = "pph21"
        } else if (tipe.toLowerCase() == "ppn") {
          tipe = "ppn"
        } else if (tipe.toLowerCase() == "pphuni") {
          tipe = "unifikasi"
        }
        ids = ids[1].split(".")
        if (ids[0] == 'SPT') {
          manifest = "SPTManifest";
          this.$router.push({ name: manifest, params: { id: id_, tipe: tipe } });
        } else {
          manifest = "PiManifest";
          this.$router.push({ name: manifest, params: { id: id_, tipe, tlc: this.getAuth.username, user_pembuat: null } });
        }
      } else {
        if (jenis == "pi") {
          manifest = "PiManifest";
        } else if (jenis == "umpp") {
          manifest = "UmppManifest";
        } else if (jenis == "umpd") {
          manifest = "umpd_manifest";
        } else if (jenis == "klaimpd") {
          manifest = "manifestKlaimPd";
        } else if (jenis == "klaimpp") {
          manifest = "manifestKlaimPp";
        } else if (jenis == "klaimdirektur") {
          manifest = "manifestDirectur";
        } else if (jenis == "po") {
          manifest = "PoManifest";
        } else if (jenis == "wo") {
          manifest = "manifestWO";
        } else if (jenis == "pp") {
          manifest = "manifestPp";
        } else if (jenis == "kas_kecil") {
          manifest = "manifestLaporanKasKecil";
        } else if (jenis == "sppd") {
          manifest = "manifest";
        } else if (jenis == "lk_um_pp") {
          manifest = "lapUmppManifest";
        } else if (jenis == "lk_um_pd") {
          manifest = "manifestLaporanUmpd";
        } else if (jenis == "addendum") {
          manifest = "AddendumManifest";
        } else if (jenis == "am") {
          manifest = "AccountMutationManifestKeu";
        } else if (jenis == "financing") {
          manifest = "financing-manifest";
        } else if (jenis == "payment_schedule") {
          manifest = "PaymentScheduleManifestKeu";
        } else if (jenis == "bidbond_request") {
          manifest = "bidBondRequest-manifestKeu";
        } else if (jenis == "bidbond") {
          manifest = "bidBond-manifestKeu";
        } else if (jenis == "other_outcome") {
          manifest = "OtherOutcomeManifestKeu";
        } else {
          manifest = "Manifest";
        }
        this.$router.push({ name: manifest, params: { id: id_ } });
      }
    },
    addLampiran(e) {
      e.stopPropagation();
      this.visibleLampiran = !this.visibleLampiran;

      if (this.jenistransaksi !== 'am' && this.currencyorigin !== 'IDR') {
        //this.totalRealCostList = 0;
        //this.totalCost = 0;
        this.totalCostBKK = 0;
        this.cost_bkk = [];
        for (let index = 0; index < this.list_data.length; index++) {
          this.list_data[index].value_data = this.list_data[index].currency != "IDR" && this.list_data[index].currency == this.list_data[index].currency_to ?
            1 : 0;
          this.list_data[index].value_real = this.list_data[index].currency != "IDR" && this.list_data[index].currency == this.list_data[index].currency_to ?
            this.list_data[index].value_real : 0;

          this.currency = this.list_data[index].currency != "IDR" && this.list_data[index].currency == this.list_data[index].currency_to ?
            this.list_data[index].currency_to : this.currency
        }
      }
    },
    handleDownload(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
    handleRemoveExisting(id) {
      this.confirmMessageValue("confirm-delete", id);
    },
    removeCostBKK(val) {
      this.cost_bkk.splice(
        this.cost_bkk.findIndex((v) => v.no === val.no),
        1
      );
      this.cost_bkk = this.cost_bkk.map((values, index) => {
        values.no = index + 1;
        return values;
      });

      this.totalCostBKK = this.cost_bkk.reduce(function (prev, cur) {
        return prev + Number(cur.cost_value);
      }, 0);

      this.displayMessage("success-del");
    },
    handleRemoveLampiran(item) {
      this.pageLoading = true;
      const serviceUrl = this.$serviceUrl;
      const auth = {
        username: this.getAuth.username,
        password: this.getAuth.password,
        apikey: this.getAuth.apikey,
      };
      axios({
        method: "delete",
        url: serviceUrl + "bkk/delete_bkk",
        processData: false,
        data: {
          id_bkk: item,
        },
        auth: {
          username: auth.username,
          password: auth.password,
        },
        headers: {
          "X-API-KEY": auth.apikey,
        },
      })
        .then((response) => {
          this.pageLoading = false;
          Event.$emit("refresh", true);
          if (response.data.message === "Document has been Delete") {
            this.displayMessage("success-del");
          } else {
            let responses = Object.assign({}, response.data);
            this.displayMessageValue("error", responses);
          }
        })
        .catch((err) => {
          this.pageLoading = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error", responses);
        });
    },
    handlePrintManifest() {
      this.printLoad = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "bkk/cetak_bkk",
        responseType: "blob",
        params: {
          id_bkk: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.printLoad = false;
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad = false;
          this.$router.go(-1);
        });
    },
    handleTambahCostBKK() {
      this.formCost.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if (this.statusEditCostBKK) {
          this.cost_bkk = this.cost_bkk.map((items, index) => {
            if (items.no === this.keyEditCostBKK.no) {
              items.cost_name = values.cost_name;
              items.cost_value = values.cost_value;
            }
            return items;
          });
          this.statusEditCostBKK = false;
        } else {
          let cost_object = {
            no: 1,
            cost_name: values.cost_name,
            cost_value: values.cost_value,
          };
          this.cost_bkk.push(cost_object);
          this.cost_bkk = this.cost_bkk.map((values, index) => {
            values.no = index + 1;
            return values;
          });
        }
        this.totalCostBKK = this.cost_bkk.reduce(function (prev, cur) {
          return prev + Number(cur.cost_value);
        }, 0);

        this.formCost.resetFields();
        this.displayMessage("success-save");
      });
    },
    handleEditCostBKK(val) {
      this.formCost.setFieldsValue({ cost_name: val.cost_name });
      this.formCost.setFieldsValue({ cost_value: val.cost_value });
      this.keyEditCostBKK = val;
      this.statusEditCostBKK = true;
    },
    handleRemoveCostBKK(val) {
      this.confirmMessageValue("confirm-delete-clear", val);
    },
    handleUploadLampiran() {
      this.formLampiran.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if (this.fileListLampiran.length == 0) {
          this.displayMessage("form-warning");
          return;
        }

        let formData = new FormData();
        formData.append("id_bkk", this.id);
        formData.append("tlc", this.getAuth.username);
        formData.append("document_name", values.document_name);
        formData.append("document_upload", values.file_list_lampiran.file);

        if (this.data.header.no_bg != '') {
          formData.append("tgl_jatuh_tempo", moment(values.due_date).format("YYYY-MM-DD"));
        }

        if (this.visible_value_bkk) {
          let list_data_validate = this.list_data.filter((value) => {
            if (value.value_data <= 0) {
              return value;
            }
          });

          if (list_data_validate.length > 0) {
            this.displayMessage("value-0");
            return;
          }
        }

        let id_dtl_bkk = "";
        let kurs_dtl_bkk = "";
        let value_dtl_bkk = "";

        if (this.list_data.length > 0) {
          let stoper = this.list_data.length - 1;
          for (let index = 0; index < this.list_data.length; index++) {
            id_dtl_bkk =
              id_dtl_bkk +
              this.list_data[index].bkk_dtl_id +
              (stoper != index ? "," : "");
            kurs_dtl_bkk =
              kurs_dtl_bkk +
              this.list_data[index].value_data +
              (stoper != index ? "," : "");
            value_dtl_bkk =
              value_dtl_bkk +
              this.list_data[index].value_real +
              (stoper != index ? "," : "");
          }
        }

        formData.append("id_dtl_bkk", id_dtl_bkk);
        formData.append("kurs_dtl_bkk", kurs_dtl_bkk);
        formData.append("value_dtl_bkk", value_dtl_bkk);

        let cost_names_bkk = "";
        let cost_values_bkk = "";

        if (this.cost_bkk.length > 0) {
          for (let index = 0; index < this.cost_bkk.length; index++) {
            cost_names_bkk =
              cost_names_bkk +
              this.cost_bkk[index].cost_name +
              (index !== this.cost_bkk.length - 1 ? ";" : "");
            cost_values_bkk =
              cost_values_bkk +
              this.cost_bkk[index].cost_value +
              (index !== this.cost_bkk.length - 1 ? ";" : "");
          }
        }
        formData.append("cost_name_bkk", cost_names_bkk);
        formData.append("cost_value_bkk", cost_values_bkk);
        formData.append("is_rounding", this.isRoundingBKKValue);
        this.uploadLoading = true;
        axios({
          method: "post",
          url: this.$serviceUrl + "bkk/upload_bkk",
          processData: false,
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.uploadLoading = false;
            this.displayMessage("success-upload");
            this.visibleLampiran = !this.visibleLampiran;
            this.$router.go(0);
          })
          .catch((err) => {
            this.uploadLoading = false;
            console.log("error : " + err);
          });
      });
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.fileListLampiran.push(file);
        return false;
      }
    },
    beforeUploadFile(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 2) {
        this.displayMessage("large-file-2mb");
      } else {
        this.pushfile = [file];
        this.tlForm.upload = file;
        return false;
      }
    },
    beforeUploadTransfer(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 10) {
        this.displayMessage("large-file-10mb");
      } else {
        this.fileList = []
        this.fileList.push(file);
        return false;
      }
    },
    handleRemoveFile() {
      this.pushfile = null;
      this.$refs.tlForm.upload = null;
    },
    cancelLampiran() {
      this.fileListLampiran = [];
      this.formLampiran.resetFields();
      this.popoverdtlpendanaan = null;
    },
    handleRemove(file) {
      const index = this.fileListLampiran.indexOf(file);
      const newFileList = this.fileListLampiran.slice();
      newFileList.splice(index, 1);
      this.fileListLampiran = newFileList;
    },
    handleRemoveTransfer() {
      this.fileList = null;
    },
    editList() {
      this.editModal = true;
      this.activeKey = ["0"];
      this.search = "";
      // this.fetchData();
    },
    handleClose() {
      this.editModal = false;
      this.list_process = [];
    },
    handleEditModal() { },
    changeActionItem(item) {
      let cur = item.currency;
      let status = false;
      let jns = false;
      const temp = this.list_process;
      if (
        item.jenis == "am" &&
        (this.selectedData[0] ? this.selectedData[0].jenis : "am") !== "am"
      ) {
        jns = true;
        if (item.dana_sts === false) {
          this.list_process = [];
        }
      } else if (
        item.jenis !== "am" &&
        (this.selectedData[0] ? this.selectedData[0].jenis : "") == "am"
      ) {
        jns = true;
        if (item.dana_sts === false) {
          this.list_process = [];
        }
      }

      if (!jns) {
        for (let index = 0; index < this.selectedData.length; index++) {
          if (cur !== this.selectedData[index].currency) {
            status = false;
            if (cur !== "IDR" && this.selectedData[index].currency !== "IDR") {
              status = false;
            } else {
              status = true;
              if (item.dana_sts === false) {
                this.list_process = [];
              }
              break;
            }
          }
        }
      }

      if (jns) {
        this.displayMessageValue(
          "error-other",
          "The type transaction is not same!"
        );
        setTimeout(
          function () {
            this.list_process = temp;
          }.bind(this),
          100
        );
        return;
      }

      if (status) {
        if (item.dana_sts === false) {
          this.displayMessageValue("error-other", "The Currency is not same!");
          setTimeout(
            function () {
              this.list_process = temp;
            }.bind(this),
            100
          );
          return;
        }
      }

      for (let index = 0; index < this.list_process.length; index++) {
        if (this.list_process[index].key === item.key) {
          let statusDana = false;
          if (item.dana_sts === true) {
            statusDana = false;
          } else {
            statusDana = true;
          }

          this.list_process[index].dana_sts = statusDana;
          for (let i = 0; i < this.basedListprocess.length; i++) {
            if (
              this.basedListprocess[i].number ===
              this.list_process[index].number
            ) {
              this.basedListprocess[i].dana_sts = statusDana;
            }
          }
        }
      }

      this.sortListProcess();
    },
    sortListProcess() {
      this.list_process = this.ArrshortMultiCol(this.list_process, {
        dana_sts: "desc",
        key: "asc",
      });

      this.selectedData = this.basedListprocess.filter(
        (item) => item.dana_sts == true
      );
    },
    fetchData() {
      this.listProcessLoading = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "bkk/fetch_bkk_for_edit",
        params: {
          id_bkk: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.list_process = response.data.data;
          for (let index = 0; index < this.list_process.length; index++) {
            let status = false;
            if (this.list_process[index].bkk_dtl_id !== null) {
              status = true;
            }
            let col = [
              {
                ...this.list_process[index],
                number: index + 1,
                key: index + 1,
                dana_sts: status,
              },
            ];
            this.list_process[index] = col[0];
          }

          this.tlForm = {
            type: response.data.type_number,
            no_bilyet: response.data.no_bilyet,
            no_cek: response.data.no_cek,
            no_atm: response.data.no_atm,
            typeValue:
              response.data.type_number == "bilyet_giro"
                ? response.data.no_bilyet
                : response.data.type_number == 'no_cek' ? response.data.no_cek :
                  response.data.type_number == 'auto_debet' ? response.data.auto_debet : response.data.no_atm,
            auto_debet: response.data.auto_debet,
            trans_date: moment(response.data.trans_date),
          };
          this.changegenBKKval = response.data.type_number;

          if (response.data.file_support != null) {
            let typefile = this.fileTypeFromUrl(response.data.file_support);
            let file = this.dataURLtoFile(typefile + response.data.files, response.data.file_support);
            file.uid = 'vc-upload-1-1';
            file.status = 'done';
            file.exist = true;
            file.url = this.$serviceUrl + response.data.file_support_url;
            this.pushfile = [];
            this.pushfile.push(file);
          }
          // file.uid = "vc-upload-1-1";
          // file.status = "done";
          // file.exist = true;
          // file.url = this.$serviceUrl + res.hdr[0].file_url;
          // this.dataProcessed.information.attachment=[file];


          this.basedListprocess = this.list_process;
          this.listProcessLoading = false;

          this.sortListProcess();
        })
        .catch((err) => {
          this.listProcessLoading = false;
          this.displayMessage("error-connection");
        });
    },
    handleCancelEdit() {
      this.editModal = false;
      this.list_process = [];
    },
    handleSubmitEdit() {
      if (
        this.$refs.tlForm.validate((valid) => {
          if (!valid) {
            this.displayMessage("form-warning");
            return;
          }

          if (this.selectedData.length == 0) {
            this.displayMessageValue(
              "error-other",
              "Please select data to submit!"
            );
            return;
          }

          let data = new FormData();
          data.append("tlc", this.getAuth.username);
          data.append("id_bkk", this.id);
          data.append("no_bg", this.tlForm.type == "bilyet_giro" ? this.tlForm.typeValue : "");
          data.append("no_cek", this.tlForm.type == "no_cek" ? this.tlForm.typeValue : "");
          data.append("no_atm", this.tlForm.type == "no_atm" ? this.tlForm.typeValue : "");
          data.append("selected_item", JSON.stringify(this.selectedData));
          data.append("is_rounding", this.isRoundingBKKValue);

          if (this.tlForm.type == "no_cek" || this.tlForm.type == "no_atm") {
            data.append("trans_date", moment(this.tlForm.trans_date).format("YYYY-MM-DD"));
          }

          if (this.tlForm.type == "auto_debet") {
            data.append("trans_date", moment(this.tlForm.trans_date).format("YYYY-MM-DD"));
            data.append("auto_debet", this.tlForm.typeValue);
            data.append("file_support", this.pushfile[0]);
          } else {
            data.append("auto_debet", "");
          }

          this.submitLoading = true;
          axios({
            method: "post",
            url: this.$serviceUrl + "bkk/submit_edit_bkk",
            processData: false,
            data: data,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessageValue("success-other", response.data.message);
              this.submitLoading = false;
              this.editModal = false;
              this.pushfile = [];
              this.tlForm.upload = [];
              this.fetchManifest();
              // this.fetchData();
            })
            .catch((err) => {
              this.submitLoading = false;
              let responses = Object.assign({}, err.response);
              this.displayMessageValue("error", responses);
            });
        })
      );
    },
    onChangeSearch(e) {
      let tempData = this.basedListprocess;
      if (tempData.length > 0) {
        if (this.search) {
          tempData = tempData.filter(
            (obj) =>
              (obj.no &&
                obj.no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.deskripsi &&
                obj.deskripsi
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tgl_transaksi &&
                this.moment(obj.tgl_transaksi)
                  .format(this.getDefaultDateFormat)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value &&
                this.formatCurrency(obj.currency, obj.value)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tlc_updated &&
                this.formatCurrency(obj.currency, obj.tlc_updated)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0)
          );
        }
        this.list_process = tempData;
        this.sortListProcess();
      }
    },
    handlePreview(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
    handlechangegenBKK(val) {
      this.changegenBKKval = val.target.value;
      if (val.target.value == 'auto_debet') {
        this.tlForm.upload = null;
        this.pushfile = null;
        this.tlForm.trans_date = null;
      }
      this.tlForm.auto_debet = null;
      this.tlForm.no_atm = null;
      this.tlForm.no_bilyet = null;
      this.tlForm.no_cek = null;
    },
    disabledDate(current) {
      // Can not select days before today and today
      return this.changegenBKKval == "auto_debet" ? false : (current && current < moment().subtract(1, 'days'));
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    async handleShowTaxModal(item) {
      this.datapajak.tax_type = item.type_tax;
      this.datapajak.kode_setoran_pajak = item.kode_setoran_pajak;
      this.datapajak.objek_pajak = item.kode_objek_pajak;
      this.datapajak.id_header = this.id;
      this.datapajak.id_dtl = item.id_dtl;
      this.datapajak.dpp_value = item.dpp_value;
      this.datapajak.value = item.tax_value;
      this.datapajak.getListsetoranpajak = _.filter(this.data.setoran_pajak, (obj) => obj.id_type_tax == item.type_tax);
      this.datapajak.getListobjekpajak = _.filter(this.data.objek_pajak, (obj) => obj.id_type_tax == item.type_tax);

      if (item.file_doc_tax != null && item.file_doc_tax != "No File Uploaded") {
        let typefile = this.fileTypeFromUrl(item.file_doc_tax);
        let file = this.dataURLtoFile(typefile + item.document_file, item.file_doc_tax);
        file.uid = 'vc-upload-1-1';
        file.status = 'done';
        file.url = this.$serviceUrl + item.document_path;
        this.datapajak['fileList'] = [];
        this.datapajak.fileList.push(file);
      }
      this.visibleTaxModal = true;
    },
    toKodeSetoran(e) {
      e.stopPropagation();
      this.visibleTaxModal = !this.visibleTaxModal;
    },
    taxDepositEntryCancel() {
      this.visibleTaxModal = false;
    },
    taxDepositEntryUpdate(val) {
      let index1 = _.findIndex(this.data.dtl_invoiceOri, {
        id_dtl: val.id_dtl,
      });

      // this.data.dtl_invoiceOri[index1].file_doc_tax = val.document_tax;
      // this.data.dtl_invoiceOri[index1].document_tax = val.document_tax;
      // this.data.dtl_invoiceOri[index1].document_path = val.document_path;
      this.data.dtl_invoiceOri[index1].tax_value = val.tax_value;
      this.data.dtl_invoiceOri[index1].kode_objek_pajak =
        val.objek_pajak;
      this.data.dtl_invoiceOri[index1].kode_setoran_pajak =
        val.kode_setoran_pajak;
      this.data.dtl_invoiceOri[index1].dpp_value = val.dpp_value;
      let index2 = _.findIndex(this.data.dtl_invoice, {
        id_dtl: val.id_dtl,
      });
      // this.data.dtl_invoiceOri[index2].file_doc_tax = val.document_tax;
      // this.data.dtl_invoiceOri[index2].document_tax = val.document_tax;
      // this.data.dtl_invoiceOri[index2].document_path = val.document_path;
      this.data.dtl_invoice[index2].tax_value = val.tax_value;
      this.data.dtl_invoice[index2].kode_objek_pajak =
        val.objek_pajak;
      this.data.dtl_invoice[index2].kode_setoran_pajak =
        val.kode_setoran_pajak;
      this.data.dtl_invoice[index2].dpp_value = val.dpp_value;
    },
    handleActionConfirm() {
      let sts = this.form.getFieldValue("aksi");
      if (sts == "Verified" && this.isValidTaxOfficerValue) {
        this.confirmMessage("confirm-save");
      } else if (sts !== "Verified") {
        this.confirmMessage("confirm-save");
      } else {
        this.displayMessageValue(
          "error-other",
          "There is still Document Tax data that hasn't been filled in!"
        );
      }
    },
    handleAction() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        let addData = new FormData();
        addData.append("id_manifest", this.data.invoice[0].id_rilis);
        addData.append("status", values.aksi);
        addData.append("remark", values.catatan ? values.catatan : "");

        if (this.data.jenis === "Transfer") {
          addData.append("file_transfer", values.file_transfer.file);
          addData.append("status", "Transferred");
          addData.append(
            "tgl_transfer",
            moment(values.tgl_tf).format(this.getStandartFormatDate)
          );

          if (this.checkTransferValue) {
            addData.append("cek_value", 1);
            addData.append("value_transfer", 0);
          } else {
            addData.append("cek_value", 0);
            addData.append("value_transfer", values.value_transferan);
          }
        }

        this.loading.trans_verif = true;
        axios({
          method: "post",
          url: this.$serviceUrl + "rekap/rilis_approve",
          processData: false,
          data: addData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success");
            /* this.$router.push({ name: "po" }); */
            this.$router.go(0);
          })
          .catch((err) => {
            this.loading.trans_verif = false;
            console.log("error : " + err);
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
          });
      });
    },
    handleCancel() {
      this.loading.cancel = true;
      let data = new FormData();
      data.append("tlc", this.getAuth.username);
      data.append("id_manifest", this.id);
      data.append("jenis_trans","rilis_rekap");
      this.asyncAxiosPost(
        "main/cancel_transaction",
        "formdata",
        this.getAuth,
        data
      )
        .then((response) => {
          this.displayMessage("success-cancel");
          this.loading.cancel = false;

          this.$router.go(0);
        })
        .catch((err) => {
          this.loading.cancel = false;
          let response = Object.assign({}, err.response);
          if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-other", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          }
        });
    },
    handleEdit(id) {
      this.$router.push({
        name: "PIReleaseEdit",
        params: { idrilisedit: id },
      });
    },
    onChangeStatus(val) {
      if (val === "Transferred") {
        this.reqFileTf = true;
      }
    },
    onchangeNilaiTf(e) {
      this.disableNilaiTf = e.target.checked;
      if (e.target.checked) {
        this.cek_value = 1;
        this.checkTransferValue = true;
        this.form.setFieldsValue({ value_transferan: this.sisa_tf });
      } else {
        this.cek_value = 0;
        this.checkTransferValue = false;
      }
    },
    handleViewDt(file) {
      if (file.url.substr(file.url.length - 3) === "pdf") {
        window.open(this.$serviceUrl + file.url, "_blank");
      } else {
        this.previewImage = this.$serviceUrl + file.url;
        this.previewVisible = true;
      }
    },
    handleCancelPreview() {
      this.previewVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.table-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: @padding;

  &-extra {
    display: flex;
    justify-content: space-between;
    gap: @padding;
    width: 500px;
  }

  .title {
    color: @color-secondary;
  }
}
</style>
